import type { AccessLevel } from "@/types";

const ACCESS_RANK: Record<AccessLevel, number> = {
  member: 0,
  organizer: 10,
  admin: 100,
};

/** True when `level` is at or above `minimum`. Absent never satisfies. */
export function atLeastAccess(
  level: AccessLevel | undefined,
  minimum: AccessLevel,
): boolean {
  if (!level) return false;
  return ACCESS_RANK[level] >= ACCESS_RANK[minimum];
}
